export default __webpack_public_path__ + "static/media/image@3x.ccf7b961.png";